"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFetchQuickReplies = exports.MAX_QUICK_REPLY_LENGTH = exports.MAX_QUICK_REPLIES = void 0;
const react_1 = require("react");
const context_1 = require("../context");
exports.MAX_QUICK_REPLIES = 10;
exports.MAX_QUICK_REPLY_LENGTH = 500;
const useFetchQuickReplies = () => {
    const { selectedOrgUser } = (0, react_1.useContext)(context_1.OrganizationContext);
    const [quickReplies, setQuickReplies] = (0, react_1.useState)((selectedOrgUser === null || selectedOrgUser === void 0 ? void 0 : selectedOrgUser.quickReplies) || []);
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const fetchQuickReplies = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            setIsLoading(true);
            yield selectedOrgUser.fetchQuickReplies();
            setQuickReplies((selectedOrgUser === null || selectedOrgUser === void 0 ? void 0 : selectedOrgUser.quickReplies) || []);
        }
        finally {
            setIsLoading(false);
        }
    });
    const addQuickReply = (quickReply) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            setIsLoading(true);
            yield selectedOrgUser.addQuickReplies(quickReply);
            setQuickReplies((selectedOrgUser === null || selectedOrgUser === void 0 ? void 0 : selectedOrgUser.quickReplies) || []);
        }
        finally {
            setIsLoading(false);
        }
    });
    const deleteQuickReply = (index) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            setIsLoading(true);
            yield selectedOrgUser.deleteQuickReplies(index);
            setQuickReplies((selectedOrgUser === null || selectedOrgUser === void 0 ? void 0 : selectedOrgUser.quickReplies) || []);
        }
        finally {
            setIsLoading(false);
        }
    });
    return {
        quickReplies,
        fetchQuickReplies,
        addQuickReply,
        deleteQuickReply,
        isLoading,
    };
};
exports.useFetchQuickReplies = useFetchQuickReplies;
